import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) => `/login${redirectTo ? `?redirectTo=${redirectTo}` : ''}`,
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },

  org: {
    root: {
      path: '/o',
      getHref: () => '/o',
    },
    selected: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    userProfile: {
      path: 'profile',
      getHref: (orgId?: string) => (orgId ? `/o/${orgId}/profile` : '/o/profile'),
    },
    webhooks: {
      path: 'webhooks',
      getHref: (orgId: string) => `/o/${orgId}/webhooks`,
    },
    webhookDetail: {
      path: 'webhooks/:webhookId',
      getHref: (orgId: string, webhookId: string) => `/o/${orgId}/webhooks/${webhookId}`,
    },
    webhookEventDetail: {
      path: 'webhooks/:webhookId/events/:eventId',
      getHref: (orgId: string, webhookId: string, eventId: string) =>
        `/o/${orgId}/webhooks/${webhookId}/events/${eventId}`,
    },
    orgProfile: {
      path: 'org',
      getHref: (orgId: string) => `/o/${orgId}/org`,
    },
    emailTemplate: {
      path: 'email-template',
      getHref: (orgId: string) => `/o/${orgId}/email-template`,
    },
    user: {
      path: 'users/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/users/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    apps: {
      path: 'apps',
      getHref: (orgId: string) => `/o/${orgId}/apps`,
    },
    app: {
      path: 'apps/:appId',
      getHref: (orgId: string, appId: string) => `/o/${orgId}/apps/${appId}`,
    },
  },

  admin: {
    root: {
      path: '/admin',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'users/:userId',
      getHref: (userId: string) => `/admin/users/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
    webhooks: {
      path: 'webhooks',
      getHref: () => '/admin/webhooks',
    },
    terms: {
      path: 'terms',
      getHref: () => '/admin/terms',
    },
    termsCreate: {
      path: 'terms/create',
      getHref: () => '/admin/terms/create',
    },
    termsDetail: {
      path: 'terms/:termsId',
      getHref: (termsId: string) => `/admin/terms/${termsId}`,
    },
  },

  app: {
    root: {
      path: '/app',
      getHref: () => '/app',
    },
    selected: {
      path: ':appId',
      getHref: (appId: string) => `/app/${appId}`,
    },
    dashboard: {
      path: '',
      getHref: (appId: string) => `/app/${appId}`,
    },
    organizations: {
      path: 'organizations',
      getHref: (appId: string) => `/app/${appId}/organizations`,
    },
    appAssignment: {
      path: 'organizations/:orgId',
      getHref: (appId: string, orgId: string) => `/app/${appId}/organizations/${orgId}`,
    },
    roles: {
      path: 'roles',
      getHref: (appId: string) => `/app/${appId}/roles`,
    },
    users: {
      path: 'users',
      getHref: (appId: string) => `/app/${appId}/users`,
    },
    appProfile: {
      path: 'profile',
      getHref: (appId: string) => `/app/${appId}/profile`,
    },
    emailTemplate: {
      path: 'email-template',
      getHref: (appId: string) => `/app/${appId}/email-template`,
    },
    user: {
      path: 'users/:userId',
      getHref: (appId: string, userId: string) => `/app/${appId}/users/${userId}`,
    },
    webhooks: {
      path: 'webhooks',
      getHref: (appId: string) => `/app/${appId}/webhooks`,
    },
    webhookDetail: {
      path: 'webhooks/:webhookId',
      getHref: (appId: string, webhookId: string) => `/app/${appId}/webhooks/${webhookId}`,
    },
    webhookEventDetail: {
      path: 'webhooks/:webhookId/events/:eventId',
      getHref: (appId: string, webhookId: string, eventId: string) =>
        `/app/${appId}/webhooks/${webhookId}/events/${eventId}`,
    },
    terms: {
      path: 'terms',
      getHref: (appId: string) => `/app/${appId}/terms`,
    },
    termsDetail: {
      path: 'terms/:termsId',
      getHref: (appId: string, termsId: string) => `/app/${appId}/terms/${termsId}`,
    },
  },
} as const;
